import React from 'react';
import PropTypes from 'prop-types';
import { RendererContext, ThemeContext } from 'react-fela';

const FelaKeyFrame = ({ children, keyframe, ...props }) => {
    const renderer = React.useContext(RendererContext);
    const theme = React.useContext(ThemeContext);
    const animationName = React.useMemo(() => renderer.renderKeyframe(keyframe, { ...props, theme }), [
        keyframe,
        renderer,
        theme,
        props,
    ]);
    return children(animationName);
};

FelaKeyFrame.propTypes = {
    children: PropTypes.func.isRequired,
    keyframe: PropTypes.func.isRequired,
};

export default FelaKeyFrame;
